import $ from 'jquery'

const Switcher = {
  HOOK_ROOT: '.js-switcher',
  HOOK_CONTENT: '.switcher_content',
  HOOK_ITEM: '.switcher_item',
  HOOK_DELETE: '.js-switcher-delete',

  init: function () {
    // Switch between options
    $(document).on('change', Switcher.HOOK_ROOT + ' input', Switcher.change)

    // Delete option
    $(document).on('click', Switcher.HOOK_DELETE, Switcher.delete)
  },

  change: function (event) {
    event.preventDefault()

    // Hide all content inside switcher
    $(this)
      .parents(Switcher.HOOK_ROOT)
      .find(Switcher.HOOK_CONTENT)
      .addClass('is-hidden')

    // Show selected content
    $(this)
      .parents(Switcher.HOOK_ITEM)
      .find(Switcher.HOOK_CONTENT)
      .removeClass('is-hidden')
  },

  delete: function (event) {
    event.preventDefault()

    const message = $(this).attr('data-confirmation')
    const $parent = $(this).parents(Switcher.HOOK_ITEM)

    // Show delete confirmation
    if (window.confirm(message)) {
      // Hide item
      $parent.addClass('is-hidden')

      // Sleect first option if this one was checked
      if ($parent.find('input').prop('checked')) {
        $(Switcher.HOOK_ROOT + ' input:visible:first').prop('checked', true)
      }
    }
  },
}

$(Switcher.init)
